export default () => ({
  horseName: {
    fontSize: 20,
    lineHeight: '20px',
  },
  horseShowName: {
    color: '#858585',
    fontSize: 14,
  },
  miniAvatar: {
    display: 'inline-block',
    height: 32,
    width: 32,
  },
  miniImg: { verticalAlign: 'top' },
  bordered: { border: '2px solid white' },
});
